export const useLoadInit = () => useState<boolean>('load-init');
